var _path, _path2, _path3, _path4, _path5, _path6, _g, _ellipse, _ellipse2, _rect, _rect2, _ellipse3, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse4, _path14, _path15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFamilyActivities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 52,
    viewBox: "0 0 60 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.568 34.166c-.375-.203-2.667-1.554-3.729-3.917-.509-1.133-.433-2.247.29-3.27.498-.703 1.052-1.366 1.57-2.054.83-1.102.872-2.157.09-3.305-.777-1.143-1.395-2.337-1.603-3.733-.247-1.657.496-3.721 2.263-4.376.91-.337 1.106-1.085.876-2.06-.085-.365-.24-.717-.39-1.062-.225-.518-.436-1.05-.722-1.534-.636-1.08-.672-2.142-.127-3.274.97-2.017 2.19-3.823 4.106-5.043.667-.425 1.403-.622 2.232-.504 1.061.15 1.612.975 1.656 2.024.037.887-.136 1.753-.322 2.613-.205.952-.497 1.89-.637 2.851-.136.927-.228 1.88.175 2.788.506 1.144 1.508 1.678 2.574 2.134.849.364 1.746.612 2.556 1.068.449.254.851.555 1.205.954.817.922.666 2.112.114 3.025-.482.797-1.137 1.458-1.698 2.194-.19.249-.383.499-.543.768-.43.721-.248 1.435.425 1.948.468.356 1.033.519 1.516.843 1.107.744 1.68 1.792 1.783 3.11.186 2.367-.741 4.317-2.265 6.033a8.77 8.77 0 0 1-1.897 1.616 8.904 8.904 0 0 1-3.177 1.215c-1.542.27-2.745.064-3.378-.05a9.55 9.55 0 0 1-2.943-1.002z",
    fill: "#757D99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.695 21.468c.185-1.996 3.049-2.543 2.85-4.16-.209-1.687-3.397-1.662-4.01-3.98-.317-1.197.43-1.591.172-3.515-.226-1.68-.865-1.897-1.052-3.119-.46-3.008 2.685-6.48 3.788-6.105.485.165.689 1.086.711 1.633.037.89-.134 1.757-.318 2.619-.203.954-.491 1.894-.63 2.858-.135.928-.226 1.883.173 2.793.501 1.147 1.493 1.682 2.547 2.14.84.364 1.728.612 2.529 1.07.444.253.843.555 1.192.955.809.925.66 2.117.114 3.032-.477.798-1.126 1.461-1.68 2.198-.19.25-.38.5-.538.77-.425.724-.246 1.439.42 1.952.464.357 1.022.52 1.5.846 1.096.745 1.662 1.795 1.765 3.117.184 2.372-.734 4.325-2.242 6.046a8.051 8.051 0 0 1-1.876 1.62c-.164.1-1.748 1.067-2.645 1.113-.207.01 2.52-3.839 1.979-7.178-.546-3.363-4.983-4.178-4.749-6.705z",
    fill: "#47506B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.124 42.085h-.85a21.389 21.389 0 0 0 0-6.734h.85c.088.562.16 1.17.205 1.822a22.281 22.281 0 0 1-.205 4.912z",
    fill: "#757D99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.37 23.893a.448.448 0 1 1 .773-.451L59.82 48.787a.345.345 0 0 1-.596.348L44.37 23.893z",
    fill: "#FAA918"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.238 46.057h5.431l.229.538h-5.433l-.227-.538zM50.096 42.672h5.43l.23.54h-5.433l-.227-.54zM48.262 39.238h5.43l.23.54h-5.433l-.227-.54zM46.426 35.804h5.431l.228.539h-5.432l-.227-.539zM44.592 32.37h5.431l.228.538H44.82l-.227-.538zM42.758 28.936h5.431l.228.538h-5.432l-.227-.538z",
    fill: "#FAA918"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.639 23.957a.448.448 0 1 1 .774-.451L54.089 48.85a.345.345 0 0 1-.595.348L38.639 23.958zM27.024 21.972s.646-3 3.101-3 3.056 2.605 3.056 2.605l5.177 29.203h-1.34s-.768-5.556-1.106-6.358c-.339-.802-9.935-.717-10.32-.203-.386.513-1.127 6.497-1.127 6.497l-1.176.147 3.735-28.89z",
    fill: "#FAA918"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.224,
    filter: "url(#yj2fkirqaa)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.253 35.158 8.992-7.924.452 2.83-10.26 11.849.816-6.755z",
    fill: "#F36E21"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.502,
    cx: 30.684,
    cy: 36.303,
    rx: 1.37,
    ry: 1.387,
    fill: "#F36E21"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.502,
    cx: 30.684,
    cy: 40.463,
    rx: 1.37,
    ry: 1.387,
    fill: "#F36E21"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.139,
    y: 35.61,
    width: 9.589,
    height: 1.387,
    rx: 0.068,
    fill: "#F36E21"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.139,
    y: 39.77,
    width: 9.589,
    height: 1.387,
    rx: 0.068,
    fill: "#F36E21"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.822,
    cy: 21.744,
    rx: 2.055,
    ry: 1.387,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.364 21.754c.012-.015.02-.002.038.008l.324.188c.022.012.041.024.026.044-.63.784-19.664 24.452-21.832 26.602C4.82 50.68.438 49.993.03 49.924c-.019-.003-.03-.02-.03-.04v-.808a.04.04 0 0 1 .044-.042c.406.03 3.552.22 5.376-.787 1.93-1.066 22.473-25.923 22.944-26.493z",
    fill: "#FCC35D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m27.98 23.131 10.377.414s-20.283 23.837-22.24 25.744c-1.957 1.907-6.602 1.503-6.602 1.503L0 50.08s4.16-.018 5.862-1.07C7.564 47.956 27.98 23.13 27.98 23.13z",
    fill: "#FFE6AA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m.549 49.83 9.589.577v.38l-9.59-.73v-.227z",
    fill: "#FCC35D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.272 20.47c.026-.033.07 0 .065.042l-.445 3.357c0 .008.002.007-.002.013-.157.194-18.674 23.083-20.811 25.3-2.04 2.115-6.96 1.568-7.45 1.508-.023-.003-.036-.024-.031-.047l.163-.877a.041.041 0 0 1 .046-.033c.37.053 3.296.435 5.37-.55 2.136-1.016 21.645-26.794 23.095-28.712z",
    fill: "#FCC35D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.981 21.972s.646-3 3.101-3 3.056 2.605 3.056 2.605l5.177 29.203h-1.34s-.768-5.556-1.106-6.358c-.339-.802-9.935-.717-10.32-.203-.386.513-1.127 6.497-1.127 6.497l-1.176.147 3.735-28.89z",
    fill: "#FCC35D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.588,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.63 23.75c0-.128.55 0 .55 0l-4.11 26.28s3.56-26.152 3.56-26.28z",
    fill: "#FFEFC8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m39.179 23.75 3.973.04-4.045.338.072-.378z",
    fill: "#FFEFC8"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.783,
    cy: 21.744,
    rx: 2.055,
    ry: 1.387,
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5 20.358s.973-.166 1.635.52c.663.686.701 2.253.701 2.253h-.3s-.048-1.191-.628-1.9c-.58-.71-1.408-.873-1.408-.873z",
    fill: "#F36E21"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.063 21.728c.547-2.573 2.758-2.757 2.758-2.757s-1.292.256-1.989 2.107c-.696 1.85-4.275 29.785-4.275 29.785h-.31s3.27-26.562 3.816-29.135z",
    fill: "#F36E21"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "yj2fkirqaa",
    x: 24.252,
    y: 27.048,
    width: 10.631,
    height: 15.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.093,
    result: "effect1_foregroundBlur_3651_72267"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyActivities);
export default __webpack_public_path__ + "static/media/family-activities.67b36482ad9a693d6aeaa051a4188e55.svg";
export { ForwardRef as ReactComponent };